export enum SubHeaderPersistentActionsEnum {
  SET_REDUCE_SIZE = '@subHeaderPersistent/SET_REDUCE_SIZE',
}

export type SubHeaderPersistentState = { reduceSize: boolean };
